import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/iv-open-paraguacu-paulista-de-jiu-jitsu-2025/tabela-iv-open-paraguacu-paulista-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import oticaJovem from "../../assets/images/sponsors/optica-jovem.png";
import logoLoja from "../../assets/images/sponsors/xiaomi-store.jpeg";
import celularAcessorios from "../../assets/images/sponsors/celular-acessorios.png";




//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  /*  { img: torneio, url: "http://www.torneiofacil.com" }, */
  { img: oticaJovem, url: "" },
  { img: logoLoja, url: "" },
  { img: celularAcessorios, url: "" },

];


const support = [
  { img: torneio, url: "http://www.torneiofacil.com" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "23 de novembro de 2025 "
const horaEvento = "8:30h da manhã"
const tituloEvento = "IV Open Paraguaçu Paulista de Jiu Jitsu 2025"
const localEvento = "Ginasio De Esportes Silvio Magalhães Padilha"
const endereçoEvento = "Av. Siqueira Campos, 218 - Centro, Paraguaçu Paulista - SP, CEP 19700-000"
const dataDeEncerramentoIncricao = "20/NOV/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "20/NOV/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLote1 = "10/NOV/2025"
const dataDeEncerramentoInscricaoLote2 = "20/NOV/2025"

//Valores LOTE 1 até 10/11/2025
const valorinscricaoCategoriaLote1 = "125,00 (cento e vinte cinco reais)"
const valorinscricaoAbsolutoLote1 = "125,00 (cento e vinte cinco reais)"
const valorinscricaoLote1ComboGieNogi = "195,00 (cento e noventa e cinco reais)"
const valorinscricaoLote1ComboGieAbsoluto = "158,00 (cento e cinquenta e oito reais)"
const valorinscricaoLote1ComboGiNogieAbsolutoGi = "255,00 (duzentos e cinquenta e cinco reais)"

//Valores LOTE 2 até 20/11/2025
const valorinscricaoCategoriaLote2 = "145,00 (cento e quarenta e cinco reais)"
const valorinscricaoAbsolutoLote2 = "145,00 (cento e quarenta e cinco reais)"
const valorinscricaoLote2ComboGieNogi = "215,00 (duzentos e quinze reais)"
const valorinscricaoLote2ComboGieAbsoluto = "178,00 (cento e setenta e oito reais)"
const valorinscricaoLote2ComboGiNogieAbsolutoGi = "275,00 (duzentos e setenta e cinco reais)"

const dataDeDivulgacaoChaves = "22/NOV/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "Bradesco"
const tipoDeChavePix = "Telefone"
const ChavePix = "(92) 99468-5161"
const BeneficiarioDaChavePix = "José Michel Tavares Pio"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "+55 (18) 98129-0334"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi";
const slugNOGI = "iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi";
const rotaInscriçaoGi = `/enrollment/iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi`;
const rotaChecagemGi = "/check/iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi/search";
const rotaChecagemNogi = "/check/iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi/search";
const rotaChavesGi = "/tournament/keys/iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-gi"
const rotaChavesNogi = "/tournament/keys/iv-open-paraguacu-paulista-de-jiu-jitsu-paraguacu-paulista-sp-nogi"


const IvOpenParaguacuPaulistaDeJiuJitsu2025: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/iv-open-paraguacu-paulista-de-jiu-jitsu-2025/iv-open-paraguacu-paulista-de-jiu-jitsu-2025.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/iv-open-paraguacu-paulista-de-jiu-jitsu-2025/iv-open-paraguacu-paulista-de-jiu-jitsu-2025-torneio.jpeg")}
              imageMobile={require("../../assets/images/tournaments/iv-open-paraguacu-paulista-de-jiu-jitsu-2025/iv-open-paraguacu-paulista-de-jiu-jitsu-2025.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/Cz9JMn1GJpxa1Kmu6"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    O {tituloEvento} é um evento tradicional  que
                    fomenta e incentiva a prática do jiu jitsu no estado de São Paulo. As lutas
                    serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme as tabelas de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇 + CAMISA👕" >

                  <H3>Academias:</H3>
                  <P>1° lugar: R$500,00 + 🏆 Troféu </P>
                  <P>2° lugar: R$300,00 + 🏆 Troféu </P>
                  <P>3° lugar: R$150,00 + 🏆 Troféu </P>


                  <br />
                  <H3>Absoluto Masculino GI:</H3>
                  <H5>Juvenil Branca </H5>
                  <P>1° lugar: R$150,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Juvenil Azul </H5>
                  <P>1° lugar: R$300,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Branca - (juntos) </H5>
                  <P>1° lugar: R$300,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Azul - (juntos) </H5>
                  <P>1° lugar: R$500,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Roxa - (juntos) </H5>
                  <P>1° lugar: R$600,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Marrom - (juntos) </H5>
                  <P>1° lugar: R$800,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Preta - (juntos) </H5>
                  <P>1° lugar: R$1.000,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>

                  <br />

                  <H3>Absoluto Feminino GI:</H3>

                  <H5>Juvenil Branca </H5>
                  <P>1° lugar: R$150,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Juvenil Azul </H5>
                  <P>1° lugar: R$300,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Branca - (juntos) </H5>
                  <P>1° lugar: R$300,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Azul/Roxa - (juntas) </H5>
                  <P>1° lugar: R$500,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <H5>Adulto e Master Marrom/Preta - (juntas) </H5>
                  <P>1° lugar: R$800,00 + camiseta do campeonato + Medalha🥇</P>
                  <P>2° lugar: Camiseta do campeonato + Medalha🥈</P>
                  <P>3° lugar: Camiseta do campeonato + Medalha🥉</P>
                  <br />
                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                  <p>OBS: Estas premiações só irão valer para os Absolutos que tiverem 10 (DEZ)
                    ou mais atletas inscritos.</p>
                  <p>
                    Número menor até 5 (CINCO) atletas será válido metade do valor da premiação.
                  </p>
                  <p>
                    Abaixo de 5 (CINCO) atletas, apenas premiação da camiseta e a medalha.
                  </p>
                  <P>Não Haverá absoluto NOGI</P>
                  <p>
                    Mais informações sobre as inscrições para o absoluto está disponível
                    na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <P>
                    As 200 primeiras inscrições terão uma camiseta grátis!
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria Gi poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Não haverá inscrição para absoluto categoria Nogi.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em divididas em dois lotes:
                  </Span>
                  <H3>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</H3>
                  <P>Inscrição categoria Gi ou Nogi R$ {valorinscricaoCategoriaLote1} </P>
                  <P>Inscrição somente absoluto GI R$ {valorinscricaoAbsolutoLote1} </P>
                  <P>Inscrição Combo categoria GI + absoluto GI R$ {valorinscricaoLote1ComboGieAbsoluto} </P>
                  <P>Inscrição Combo categoria GI + NOGI R$ {valorinscricaoLote1ComboGieNogi} </P>
                  <P>Inscrição Combo categoria GI + NOGI + absoluto GI R$ {valorinscricaoLote1ComboGiNogieAbsolutoGi} </P>
                  <br />
                  <H3>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</H3>
                  <P>Inscrição categoria Gi ou Nogi R$ {valorinscricaoCategoriaLote2} </P>
                  <P>Inscrição somente absoluto GI R$ {valorinscricaoAbsolutoLote2} </P>
                  <P>Inscrição Combo categoria GI + absoluto GI R$ {valorinscricaoLote2ComboGieAbsoluto} </P>
                  <P>Inscrição Combo categoria GI + NOGI R$ {valorinscricaoLote2ComboGieNogi} </P>
                  <P>Inscrição Combo categoria GI + NOGI + absoluto GI R$ {valorinscricaoLote2ComboGiNogieAbsolutoGi} </P>
                  <br />
                  <H3>
                    Obs:Para as 200 (duzentas) primeiras inscrições a camisa será grátis , após isso o valor da camisa será de R$50,00 (cinquenta reais)
                  </H3>
                  <H3>
                    Obs: A venda de camisas do evento estará disponível somente até a data de encerramento do Primeiro Lote 10/NOV/2025.
                  </H3>
                  <br />


                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico
                    comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta
                    usufrui do reembolso de 80% do valor pago na inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>
                  <P>
                    1) Está sozinho na chave de luta.
                  </P>
                  <P>
                    2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                  </P>
                  <P>
                    3) Desistência por qualquer motivo.
                  </P>
                  {/* <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3> */}
                </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                  <P> Branca; </P>
                  <P> Cinza e Amarela (juntas)</P>
                  <P> Laranja e Verde(juntas)</P>
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                  {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistencia do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P>
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
         
                  <Container>
                   
                    <h5>08:00 - Abertura dos portões</h5>
                    <h5>09:00 - Cerimônia de abertura</h5>
                    <h5>09:30 - Início das lutas</h5>
                    <h5>09:30 - Pré Mirim, Mirim A e Mirim B – Todas as faixas – Masculino e Feminino</h5>
                    <h5>10:15 - Infantil A e Infantil B – Todas as faixas – Masculino e Feminino</h5>
                    <h5>11:30 - Infanto Juvenil e Juvenil – Todas as faixas – Masculino e Feminino</h5>
                    <h5>12:30 - Nogi – Pré Mirim, Mirim A, Mirim B, Infantil A e Infantil B – Todas as faixas – Masculino e Feminino</h5>
                    <h5>12:30 - Nogi – Adulto e Master – Todas as faixas – Masculino e Feminino</h5>
                    <h5>13:30 - Faixa Preta e Faixa Marrom – Adulto e Master – Masculino e Feminino</h5>
                    <h5>14:00 - Faixa Roxa – Adulto e Master – Masculino e Feminino</h5>
                    <h5>14:00 - Nogi – Infanto Juvenil e Juvenil – Todas as faixas – Masculino e Feminino</h5>
                    <h5>15:00 - Faixa Azul – Adulto e Master – Masculino e Feminino</h5>
                    <h5>15:30 - Faixa Branca – Adulto e Master – Masculino e Feminino</h5>
                    <h5>16:30 - Início de todos os Absolutos (Faixa Preta, Marrom, Roxa, Azul e Branca)</h5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                     {/*  <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li> */}
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss 
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>
                    Liberada, atleta e público levar 1L de leite.
                  </P>
                  {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5518981290334/?t=Ol%C3%A1,%20Mayana!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*IV%20OPEN%20PARAGUAÇU%20PAULISTA%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*IV%20OPEN%20PARAGUAÇU%20PAULISTA%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                {/* <TournamentEnrollmentLinkEndpage to="#"> */}
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink>

              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGi}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink>


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default IvOpenParaguacuPaulistaDeJiuJitsu2025;
